export default "<p>\n  <!-- change-password-user works! -->\n</p>\n"